<template>
	<v-dialog v-model="dialog" persistent width="500px">
		<v-card>
			<v-toolbar dark color="primary" dense>
				<v-toolbar-title style="color: white">新しいチームを作成する</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text class="mt-2">
				<v-form>
					<v-text-field v-model="name" label="チーム名" required></v-text-field>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" text @click="close"> キャンセル </v-btn>
				<v-btn color="blue darken-1" text @click="save"> 保存 </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"

export default {
	name: "CreateTeamDialog",
	props: {
		department: {},
	},
	data() {
		return {
			dialog: false,
			name: "",
		}
	},
	methods: {
		open() {
			this.dialog = true
		},
		close() {
			this.dialog = false
			this.name = ""
		},
		save() {
			// ここでチームを作成する
			if (!this.name) {
				return
			}
			const headers = authenticate.setHeader()
			axios
				.post("/erp/v1/teams", { name: this.name, department_id: this.department.id }, { headers })
				.then((response) => {
					this.$store.dispatch("setFlash", {
						text: response.data.message,
						type: "notice",
					})
					this.$emit("teamCreated")
					this.dialog = false
					this.name = ""
				})
				.catch((error) => {
					console.log(error)
					errorHandling.errorResponse(error)
				})
			this.close()
		},
	},
}
</script>

<style scoped></style>
